<template>
  <div class="box-card">
    <el-row :gutter="12">
      <el-col :span="19">
        <span class="title">SubClass导入</span>
      </el-col>
    </el-row>
    <div style="border-top:1px solid #DCDFE6;margin-top: 30px;">
      <el-button style="margin-top:15px" size="small" @click="getInfo" type="primary">
        导入
      </el-button>

      <div class="container">
        <div class="col" >
          <div class="table-title">Document :</div>
          <div>
            <el-table
              ref="multipleTable"
              stripe
              :data="documentData"
              tooltip-effect="dark"
              max-height="560"
              style="width: 100%"
              @selection-change="(e)=>{handleSelectionChange(e,'document')}"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="subclassApiName" label="subclassApiName">
              </el-table-column>
              <el-table-column prop="subclassName" label="subclassName">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="col">
          <div class="table-title">Part :</div>
          <div>
            <el-table
              ref="multipleTable"
              stripe
              :data="partData"
              tooltip-effect="dark"
              max-height="560"
              style="width: 100%"
              @selection-change="(e)=>{handleSelectionChange(e,'part')}"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="subclassApiName" label="subclassApiName">
              </el-table-column>
              <el-table-column prop="subclassName" label="subclassName">
              </el-table-column>
            </el-table>
          </div>
        </div>
        
      </div>

      
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      partData: [],
      documentData: [],
      partList:[],
      documentLsit:[]
    };
  },
  methods: {
    getInfo() {
      let PartSubClass=this.partList.map(i => i.subclassApiName),
        DocSubClass=this.documentLsit.map(i =>i.subclassApiName);
      let obj = {
        PartSubClass,
        DocSubClass
      }
      axios.post(`pmdm/agile/buildAttrInfoFromAgile${this.params(obj)}`).then((res) => {
        console.log(res);
        
        if (res.data.code ==200) {
          this.$message({
              type: "success",
              message: res.data.message,
            });
            let e = {
                "id": 1050101,
                "parentId": 10501,
                "name": "分类1050101",
                "url": "/classes",
                "icon": "",
                "type": 0,
                "order": 1,
                "perms": "",
                "children": [],
                "active": false,
                "serial": "4.1.1",
                "title": "分类",
                "path": "/classes"
            }
            this.$router.push('/classes');
            !this.isExistingTab(e.name) &&
            this.$store.commit("setShowingTabsInHome", e);
            this.$store.commit("setActivedTabInHome", e.name);
        }
      });

    },
    async getSubClass() {
      const { data:  documentData } = await axios.get(
        "pmdm/agile/getSubClassInfoByClass?getType=" + 1
      );
      const { data: partData } = await axios.get(
        "pmdm/agile/getSubClassInfoByClass?getType=" + 0
      );
      return { partData, documentData };
    },
    getData() {
      this.getSubClass().then((res) => {
        console.log(res);
        this.partData = res.partData.object;
        this.documentData = res.documentData.object;
      });
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val,name) {
      console.log(val,name);
      // this.multipleSelection = val;
      if (name == 'part') {
        this.partList = val;
      } else{
        this.documentLsit =val;
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style scoped>
.box-card {
  /* width: 100%; */
  /* height: 660px; */
  padding: 20px;
  background: #fff;
}
.title {
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
  font-size: 18px;
  height: 18px;
  line-height: 18px;
}
.table-title {
  margin: 15px;
}
.container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
/* .container  {
  background-color: #fff;
  margin-right: 10px; 
  float: left;
  width: 100%;
} */
.col {
  width: 49%;
  /* display: inline; */
}
</style>
